import {NgModule} from '@angular/core';
import {RouterModule} from "@angular/router";
import {SKIN_ANALYZER_ROUTES} from "./skin-analyzer.routes";

@NgModule({
    imports: [
        RouterModule.forChild(SKIN_ANALYZER_ROUTES),
    ],
    exports: [
        RouterModule
    ]
})
export class SkinAnalyzerRoutingModule { }
